import { Type } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';

export const STEP_PARAM_KEY = 'step';

export interface FormStepComponent {
  form: AbstractControl;
  isLoading$: Observable<boolean>;
  disableBack$: Observable<boolean>;
  next(): string | Promise<string | undefined> | Observable<string> | undefined;
  prev(): string | Promise<string> | Observable<string>;
  nextButtonText?: string;
  backButtonText?: string;
  
  /** 
   * Function that is ran after the form manager has upserted this component's form.  
   */
  onFormReady?(): void;

  /**
   * This function functions similarly to prev() or next(), however, it is ran automatically before onFormReady.
   * You can define it to make sure your form has the data from the previous pages 
   * (making sure that the user didn't jump here by link without providing us data).
   * 
   * Returning undefined (or not returning anything) from this function tells the form manager not to move you anywhere.
   * 
   * (The form manager is ready here, so you can access previous page's data.)
   */
  ensurePreviousFormsValid?(): string | undefined | void | Promise<string | undefined | void> | Observable<string>;

  /**
   * Only show the next button, which will be put at the bottom right edge of the card.
   */
  onlyShowNext?: boolean
}

export interface FormStepItem {
  title: string;
  component: Type<FormStepComponent> & { defineForm(): AbstractControl };
}

export interface FormSteps {
  default: string;
  steps: Record<string, FormStepItem>;
}
